/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import { GETCLUBINFOS, GETBANKINFO, UPDATE_UNIONPAY_INFO } from './constants'
import { responsiveArray } from 'antd/lib/_util/responsiveObserve'

export const getClubInfo = (payload) => {
  return {
    type: GETCLUBINFOS,
    payload,
  }
}
export const getBankInfo = (payload) => {
  return {
    type: GETBANKINFO,
    payload,
  }
}

// 更新银联钱包信息
export const updateUnionPayInfo = (payload) => {
  return {
    type: UPDATE_UNIONPAY_INFO,
    payload,
  }
}

//俱乐部信息
export function fetchClubInfo() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/SetClub`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubInfo(data))
    })
  }
}

//修改
export function fetchEditClubInfo(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/SetClub`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        dispatch(fetchClubInfo())
      } else {
        message.error(data.detail)
      }
    })
  }
}

//银行卡资料
export function fetchBankInfo() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/BankAccount`
    return fetchData(endpoint).then((data) => {
      dispatch(getBankInfo(data.info))
    })
  }
}

// 获取银联钱包账户相关信息
export function getUnionPayRelatedInfo() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/SetClubApi/unionPayRelatedInfo`
    return fetchData(endpoint).then((res) => {
      console.log('获取银联钱包信息', res)
      if (res.status == 1) {
        dispatch(updateUnionPayInfo(res.data))
      }
      return res
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubInfo/action.js